import React from 'react';
import PersistentDrawerLeft from '../../components/seller/Sidebar';
import UpdatePassword from '../../components/updatePassword';

export default function SellerUpdatePassword() {
  const [userData, setUser] = React.useState({});

  return (
    <div>
      <PersistentDrawerLeft userData={setUser} components={<UpdatePassword />} titleAppBar={'Ubah Password'} />
    </div>
  );
}